require("./myProfileAggregatorConsentView.scss");

// @vendors
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { formatText, getFinalTitle } = require("core/i18n").i18n;

// @constants
import { CONTEXT_KEY } from 'constants/aggregator/aggregatorConsents.constants';

// @actions
import * as aggregatorConsentsActions from "actions/aggregator/aggregatorConsents";

// @commons
import { OKCover } from "commonsComponents/OKCover";
import { OKHeaderSubPage } from "commonsComponents/OKHeaderSubPage";

// @components
import { CallMeBack } from "components/callMeBack/callMeBack";
import ConsentsChangeError from "components/myProfile/aggregatorConsentsComponents/aggregatorConsentsError";
import ConsentsChangeSuccess from "components/myProfile/aggregatorConsentsComponents/aggregatorConsentsSuccess";
import AgregatorConsentsWizard from "components/myProfile/agregatorConsentsWizard/agregatorConsentsWizard";
import ContactInfoBox from "components/myProfile/contactInfoBox/contactInfoBox";


class MyProfileAggregatorConsentView extends React.Component {
    componentDidMount() {
        this.props.aggregatorConsentsActions.fetchConsents();
    }
    buildCover() {
        const breadCrumb = [
            {
                text: formatText(`${CONTEXT_KEY}-breadcrumbModifyAggregatorConsentsPersonalData`),
                url: "/myprofile/edit",
            },
            {
                text: formatText(`${CONTEXT_KEY}-breadcrumbModifyAggregatorConsents`),
                url: "",
            },
        ];
        return (
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="pg" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={breadCrumb}
                            finalTitle={getFinalTitle(`${CONTEXT_KEY}-titleHeader`)}
                        />
                    </OKCover>
                </div>
            </div>
        );
    }
    buildContent() {
        const boxBody = ["consents-boxBody1"];
        const { immAggregatorChangeConsents } = this.props;
        const error = immAggregatorChangeConsents.get("error");
        const success = immAggregatorChangeConsents.get("success");
        const ownBusinessPurpouses = immAggregatorChangeConsents.get("ownBusinessPurpouses");
        const thirdPartiesPurpouses = immAggregatorChangeConsents.get("thirdPartiesPurpouses");

        return (
            <Fragment>
                {!error && !success && (
                    <Fragment>
                        <div className="col-xs-12 col-md-8">
                            <AgregatorConsentsWizard />
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="row">
                                <div className="col-xs-12 grid-view--variable-cell-separation">
                                    <ContactInfoBox
                                        boxTitle={formatText(
                                            "consents-boxTitle"
                                        )}
                                        boxBody={boxBody}
                                    />
                                </div>
                                <div className="col-xs-12 grid-view--fix-cell-separation">
                                    <CallMeBack
                                        hasEntrance={false}
                                        pageTitle={getFinalTitle(
                                            "consents-titleHeader"
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
                {error && !success && <ConsentsChangeError />}
                {!error && success && (
                    <ConsentsChangeSuccess
                        reset={() => this.props.aggregatorConsentsActions.reset()}
                        ownCommercialPurpousesConsent={ownBusinessPurpouses}
                        thirdPartiesCommercialPurpousesConsent={
                            thirdPartiesPurpouses
                        }
                        history={this.props.history}
                    />
                )}
            </Fragment>
        );
    }
    render() {
        return (
            <Fragment>
                {this.buildCover()}
                <div className="grid-view__body ">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {this.buildContent()}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

MyProfileAggregatorConsentView.propTypes = {
    immAggregatorChangeConsents: PropTypes.object,
    aggregatorConsentsActions: PropTypes.object,
    history: PropTypes.object.isRequired,
};
MyProfileAggregatorConsentView.defaultProps = {
    immAggregatorChangeConsents: {},
};
export default connect(
    (state) => ({
        immAggregatorChangeConsents: state.aggregatorChangeConsents,
    }),
    (dispatch) => ({
        aggregatorConsentsActions: bindActionCreators(
            aggregatorConsentsActions,
            dispatch
        ),
    })
)(MyProfileAggregatorConsentView);
